// extracted by mini-css-extract-plugin
module.exports = {"asterisk":"CurrencyInput_asterisk__raYZS","select":"CurrencyInput_select__JQjoh","fullWidth":"CurrencyInput_fullWidth__K0ueT","input":"CurrencyInput_input__QaDjD"};